import React, { useState, useEffect, useRef, useContext } from "react";
import {Form, Row, Modal} from "react-bootstrap";
import _ from "lodash";
import Dialog from '@material-ui/core/Dialog'
import {renderFormFields} from "../form/FormRenderer";
import {RequestContext} from "../../context/RequestContext";
import JobUtils from "../../utils/JobsUtils";
import {StyledBlueButton, YellowButton, StyledBlackButton} from "../../styles/BootstrapStyles";
import "../../styles/form.scss";

const SourceForm = ({ metadataFields }) => {
  const {
    sourceLocation,
    status,
    showSourceForm,
    _setShowSourceForm,
    addNewSource,
    selectedSource,
    _setSelectedSource,
    setPremiereDateConfirmed
  } = useContext(RequestContext);
  const [metadata, setMetadata] = useState({});
  const [source, setSource] = useState({});
  const [text, setText] = useState("");
  const [isDraft, setIsDraft] = useState(false);
  const duplicateRef = useRef(null);
  const [showAssetMetaData, setShowAssetMetaData] = useState(false);
  const [buttonsDisabled, setButtonsDisabled] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [defaultPremiereDateChanged, setDefaultPremiereDateChanged] = useState(false);
  const [modalTitle, setModalTitle] = useState("");
  const [modalBody, setModalBody] = useState("");
  const [modalType, setModalType] = useState("");
  const [actionState, setActionState] = useState("");
  const PREMIERE_DATE_EST_FIELD = "premiereDateEst";
  const ACTION_STATES = {
    SAVE : "save",
    SAVE_AND_DUPLICATE : "saveduplicate"
  }

  const MODAL_TYPES = {
    PREMIERE_DATE: "premiere_date",
    ERROR: "error"
  }

  const CONFIRMATION_TITLE = "Confirmation";
  const PREMIERE_DATE_BODY = "The Estimated Premiere Date is the default present date. Are you sure you want to continue?";

  useEffect(() => {
    setText(_.get(sourceLocation, "helpText", ""));
    setIsDraft(JobUtils.isDrafting(status));
    if (selectedSource) {
      setSource(selectedSource);
      _setSelectedSource({});
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setMetadata(
        metadataFields &&
        metadataFields.map((meta) => {
          meta.value = source[meta.ref];
          return Object.assign({}, meta);
        })
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [metadataFields]);

  const handleOption = (field, value, type?) => {
    let formData = duplicateRef.current;
    const fieldValue = type === 'boolean' || type === 'autocomplete' || type === 'non-edit-list' ? value : formData[field]?.value || value;
    setSource({ ...source, [field]: fieldValue });
    if (field === PREMIERE_DATE_EST_FIELD) {
      setPremiereDateConfirmed(true);
      setDefaultPremiereDateChanged(true);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setButtonsDisabled(true);
    setActionState(ACTION_STATES.SAVE);

    if (!_.isEmpty(_.get(source, "premiereDateEst")) && !defaultPremiereDateChanged && _.get(source, 'assetIdType') === 'No ID Available') {
      showPremiereDateModal();
    } else {
      saveSource();
    }
  };

  const saveSource = () => {
    addNewSource(source,() => {
      _setShowSourceForm(false);
      setButtonsDisabled(false);
    });
  }

  const handleCancel = (e) => {
    e.preventDefault();
    e.stopPropagation();
    _setShowSourceForm(false);
  }

  const handleClose = () => {
    _setShowSourceForm(false);
  };

  const handleSaveAndDuplicate = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setActionState(ACTION_STATES.SAVE_AND_DUPLICATE);
    setButtonsDisabled(true);
    let formData = duplicateRef.current;

    if (!formData.checkValidity()) {
      formData.reportValidity();
      setButtonsDisabled(false);
      return;
    }

    if (!_.isEmpty(_.get(source, "premiereDateEst")) && !defaultPremiereDateChanged && _.get(source, 'assetIdType') === 'No ID Available') {
        showPremiereDateModal();
    } else {
      saveAndDuplicate();
    }
  }

  const saveAndDuplicate = () => {
    addNewSource(source,() => {
      setSource(_.omit(source, "key"));
      setButtonsDisabled(false);
    });
  }

  const showPremiereDateModal = () => {
    setModalType(MODAL_TYPES.PREMIERE_DATE);
    setModalTitle(CONFIRMATION_TITLE);
    setModalBody(PREMIERE_DATE_BODY);
    setShowModal(true);
  }

  const clearModal = () => {
    setModalType("");
    setModalTitle("");
    setModalBody("");
    setShowModal(false);
  }

  const renderMetaDataModal = (sourceObj) => {
    let eliminateKey = ["_id"]
    if (!_.has(sourceObj, "readOnlyMetadata")) {
      return null;
    }
    return (
        <Dialog
            key={"source-modal-" + _.get(sourceObj, "key")}
            open={showAssetMetaData}
            onClose={() => {
              setShowAssetMetaData(false);
            }}
            aria-labelledby="simple-modal-title"
            aria-describedby="simple-modal-description">
          {
            <table key={"table-" + _.get(sourceObj, "key")} className={"mt-3"}>
              {_.map(_.keys(_.get(sourceObj, "readOnlyMetadata")), (key) => {
                if(eliminateKey.includes(key)){
                  return null;
                }
                let value = _.get(sourceObj.readOnlyMetadata, key);
                return (
                    <tr key={"tablerow-" + _.get(sourceObj, "key")}>
                      <td>{<b>{_.capitalize(key)}</b>}</td>
                      <td>{_.isBoolean(value) ? (value ? "Yes" : "No") : value}</td>
                    </tr>
                );
              })}
            </table>
          }
        </Dialog>
    );
  };

  return (
      <>
        <Modal        
            className="modal"
            backdrop="static"
            show={showSourceForm}
            size="lg"
            centered
            dialogClassName="modalDialog"
            onHide={handleClose}>
          <Modal.Header className="modalHeader" closeButton>
            <Modal.Title className="modalHeaderTitle">Add/Edit Source</Modal.Title>
          </Modal.Header>
          <Modal.Body className="modalBody">
            <Form
                id="my-form"
                onSubmit={handleSubmit}
                ref={duplicateRef}
                className="regularFont">
                {_.isEmpty(metadata)
                    ? null
                    : renderFormFields (
                        metadata,
                        handleOption,
                        source,
                        setSource
                    )}
              {text !== "" && text !== null ? (
                <Row
                  style={{
                    padding: "30px 15px 0 15px",
                    justifyContent: "right"
                  }}>
                    <span className="sourceFormHelperText">
                      <span
                          style={{
                            paddingRight: "8px",
                            fontWeight: "bold",
                            fontSize: "14px",
                            color: "black"
                          }}>
                        Note:
                      </span>
                      {text}
                    </span>
                </Row> )
              : null }

                <Row style={{
                  padding: "30px 15px 30px 15px",
                  justifyContent: "right"
                }}>
                  <YellowButton id={"validate-source"} hidden={true}>
                    Validate Source
                  </YellowButton>
                  <StyledBlueButton
                    id={"save-duplicate"}
                    disabled={!isDraft || buttonsDisabled}
                    onClick={handleSaveAndDuplicate}>
                    Save &amp; Duplicate
                  </StyledBlueButton>

                  <StyledBlueButton
                      onClick={() => {}}
                      id={"save"}
                      type="submit"
                      disabled={buttonsDisabled}>
                    Save
                  </StyledBlueButton>
                  <StyledBlackButton
                      id={"cancel"}
                      onClick={handleCancel}
                      disabled={buttonsDisabled}>
                    Cancel
                  </StyledBlackButton>
                </Row>
              {renderMetaDataModal(source)}
            </Form>
          </Modal.Body>
            <Modal className="modal"
                   show={showModal}
                   dialogClassName="modalDialog">
              <Modal.Header className="modalHeader">
                <Modal.Title className="modalHeaderTitle">{modalTitle}</Modal.Title>
              </Modal.Header>
              <Modal.Body className="modalBody">
                <p>{modalBody}</p>
              </Modal.Body>
              <Modal.Footer>
                <StyledBlueButton
                    onClick={() => {
                      if (modalType === MODAL_TYPES.PREMIERE_DATE) {
                        if (actionState === ACTION_STATES.SAVE) {
                          saveSource();
                        } else {
                          saveAndDuplicate();
                        }
                      } else {
                        setButtonsDisabled(false);
                      }
                      clearModal();
                    }}
                    variant="secondary">
                  OK
                </StyledBlueButton>
                {modalType === MODAL_TYPES.PREMIERE_DATE ?
                    <StyledBlackButton
                    onClick={() => {
                      setButtonsDisabled(false);
                      setDefaultPremiereDateChanged(false);
                      clearModal();
                    }}>
                  Cancel
                </StyledBlackButton>
                    : null}
              </Modal.Footer>
            </Modal>
        </Modal>
      </>
  );
};

export default React.memo(SourceForm);